import clsx from 'clsx';
import * as React from 'react';

export type CardBodyProps = React.ComponentPropsWithoutRef<'div'>;

export function CardBody(props: CardBodyProps) {
    return <div {...props} className="flex size-full flex-col items-start gap-2 p-5" />;
}

export type CardImageLayoutProps = React.ComponentPropsWithoutRef<'div'> & {
    imagePosition?: 'left' | 'right';
};

export function CardImageLayout(props: CardImageLayoutProps) {
    return (
        <div
            {...props}
            className={clsx(
                'flex max-lg:items-start lg:grid',
                'lg:has-[[data-card-image]:first-child]:grid-cols-[auto_4fr]',
                'lg:has-[[data-card-image]:last-child]:grid-cols-[4fr_auto]'
            )}
        />
    );
}

export type CardImageProps = {
    children: React.ReactNode;
    className?: string;
};

export function CardImage(props: CardImageProps) {
    return (
        <div
            data-card-image=""
            className={clsx(
                'relative mr-1 ml-5 shrink-0 py-5',
                'first:mr-1 first:ml-5',
                'last:mr-5 last:ml-1',
                props.className
            )}
        >
            {React.Children.map(props.children, (child) => {
                if (!React.isValidElement<{ className?: string }>(child)) {
                    return child;
                }
                return React.cloneElement(child, {
                    className: clsx(child.props.className, 'h-auto'),
                });
            })}
        </div>
    );
}

export type CardActionsProps = React.ComponentPropsWithoutRef<'div'>;

export function CardActions(props: CardActionsProps) {
    return <div {...props} className="mt-2 flex items-center gap-4 empty:hidden" />;
}
